import checkSubmissionsReportForErrors from "~/store/manage/validation/checkSubmissionsReportForErrors";

const VALIDATE_SUBMISSION_REPORT = (state) => {
  state.submissionsReportErrors = checkSubmissionsReportForErrors(state);
};

export default VALIDATE_SUBMISSION_REPORT;
